import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { GoogleMapComponent } from '../../../../module/google-maps/google-map.component';
import { LocalStore } from '../../../store/store.decorator';
import { StoreFinderComponent } from './../../../store/store-finder.component';
export interface IPageStoreFinderData extends NICmsContentComponent.IData {}
@Component({
    selector: 'page-component-store-finder',
    templateUrl: './page-store-finder.html',
    styleUrls: ['./page-store-finder.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [StoreFinderComponent, GoogleMapComponent, CommonModule, IfSizeDirective]
})
@ICmsComponent<PageStoreFinderComponent>({
    id: 'store-finder',
    name: 'Store finder',
    tags: ['stores', 'feature'],
    fields: [],
    isAdvanced: true
})
export class PageStoreFinderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: IPageStoreFinderData;
    @ViewChild('storeFinder')
    private storeFinderComponent?: StoreFinderComponent;
    stores: LocalStore[] = [];
    onStoreMarkerClicked(storeId: number): void {
        this.storeFinderComponent?.onStoreMarkerClicked(storeId);
    }
    onStoresUpdate(stores: LocalStore[]): void {
        this.stores = stores;
        this.detectChanges();
    }
}
